import { api } from 'boot/axios';
import { defineStore } from 'pinia';
export const useUserStore = defineStore('user', {
    state: () => ({
        user: null,
        returnUrl: null,
        loginType: null
    }),
    getters: {
        userRole: () => {
            return 'User';
        },
        sogapaAdminRole: () => {
            return 'SogapaAdministrator';
        },
        adminRole: () => {
            return 'Administrator';
        },
        isAuthenticated: (state) => state.user?.isAuthenticated ?? false,
        userName: (state) => state.user?.name ?? '',
        isSogapaAdmin: (state) => {
            const user = state.user;
            if (user) {
                return user.roles?.indexOf('SogapaAdministrator') >= 0;
            }
            return false;
        },
        isAdmin: (state) => {
            const user = state.user;
            if (user) {
                return user.roles?.indexOf('Administrator') >= 0;
            }
            return false;
        },
        isUser: (state) => {
            const user = state.user;
            if (user) {
                return user.roles?.indexOf('User') >= 0;
            }
            return false;
        },
        isRegisterFirstCommunion: (state) => {
            const user = state.user;
            if (user) {
                return user.roles?.indexOf('RegisterFirstCommunion') >= 0;
            }
            return false;
        },
        isRegisterConfirmation: (state) => {
            const user = state.user;
            if (user) {
                return user.roles?.indexOf('RegisterConfirmation') >= 0;
            }
            return false;
        },
        isServiceAttendance: (state) => {
            const user = state.user;
            if (user) {
                return user.roles?.indexOf('ServiceAttendance') >= 0;
            }
            return false;
        },
        isSubscriptionMessageNeeded: (state) => {
            const user = state.user;
            if (user) {
                return user.isSubscriptionMessageNeeded;
            }
            return false;
        },
        subscriptionMessageType: (state) => {
            const user = state.user;
            if (user) {
                return user.subscriptionMessageType;
            }
            return 'I';
        },
        subscriptionRenewalDate: (state) => {
            const user = state.user;
            if (user) {
                return user.subscriptionRenewalDate;
            }
            return '';
        },
        subscriptionRemainingDays: (state) => {
            const user = state.user;
            if (user) {
                return user.subscriptionRemainingDays;
            }
            return '0';
        }
    },
    actions: {
        async loadUser() {
            if (this.user == null) {
                const userResponse = await api.get('/api/account/whoami');
                this.user = userResponse.data;
            }
        },
        async reloadUser() {
            const userResponse = await api.get('/api/account/whoami');
            this.user = userResponse.data;
        },
        setReturnUrl(url) {
            this.returnUrl = url;
        },
        setLoginType(type) {
            this.loginType = type;
        },
        setIsSubscriptionMessageNeeded(isNeeded) {
            this.user.isSubscriptionMessageNeeded = isNeeded;
        },
    },
});
